import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getPersonajes, isApiConfigured } from "../services/api";
import CardCarousel from "./CardCarousel";
import AppCardPersonaje from "./AppCardPersonaje";

import img1 from "./Assets/img/Balloon.jpeg";
import img2 from "./Assets/img/Ben.jpeg";
import img3 from "./Assets/img/Rino.jpeg";
import img4 from "./Assets/img/Jirrafael.jpeg";
import img5 from "./Assets/img/Alfonzorro.jpeg";
import img6 from "./Assets/img/Tite.jpeg";
import img7 from "./Assets/img/La Ardilla.jpeg";
import img8 from "./Assets/img/El Castor.jpeg";

// Colores de marca de cada personaje (alineados con /personajes).
// bg/texto = fondo de la tarjeta y color del nombre (contraste >=4.5:1 verificado).
// boton = color del texto del botón "Conócelo más" sobre fondo blanco (también >=4.5:1),
// así el botón queda alineado con el color de cada tarjeta en vez de un teal genérico.
const PALETA_PERSONAJES = [
  { bg: "#FBC024", texto: "#3B2200", boton: "#8A5A00" }, // Balloon - amarillo
  { bg: "#5B2A83", texto: "#FFFFFF", boton: "#5B2A83" }, // Ben - morado
  { bg: "#3D6690", texto: "#FFFFFF", boton: "#3D6690" }, // Rino - azul
  { bg: "#D99A2B", texto: "#3B2200", boton: "#6B4500" }, // Jirrafael - dorado
  { bg: "#E37A1E", texto: "#3B2200", boton: "#8A4700" }, // Alfonzorro - naranja
  { bg: "#FBC024", texto: "#3B2200", boton: "#8A5A00" }, // Tite - amarillo
  { bg: "#F5943C", texto: "#3B2200", boton: "#8A4A0E" }, // La Ardilla - naranja claro
  { bg: "#D9701E", texto: "#3B2200", boton: "#7A3D0E" }, // El Castor - naranja tostado
];

const conColores = (lista) =>
  lista.map((p, i) => ({ ...p, ...PALETA_PERSONAJES[i % PALETA_PERSONAJES.length] }));

const defaultPersonajes = conColores([
  { imagen: img1, nombre: "Balloon" },
  { imagen: img2, nombre: "Ben" },
  { imagen: img3, nombre: "Rino" },
  { imagen: img4, nombre: "Jirrafael" },
  { imagen: img5, nombre: "Alfonzorro" },
  { imagen: img6, nombre: "Tite" },
  { imagen: img7, nombre: "La Ardilla" },
  { imagen: img8, nombre: "El Castor" },
]);

export default function PersonajesCarousel() {
  const [personajes, setPersonajes] = useState(defaultPersonajes);
  const navigate = useNavigate();
  const fetched = useRef(false);

  useEffect(() => {
    if (!isApiConfigured() || fetched.current) return;
    fetched.current = true;

    getPersonajes()
      .then((data) => {
        if (data && data.length > 0) {
          setPersonajes(conColores(data.map((p) => ({ imagen: p.imagen, nombre: p.nombre }))));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <CardCarousel
      items={personajes}
      itemsPerSlide={3}
      renderItem={(p, j) => (
        <AppCardPersonaje
          key={j}
          img={p.imagen}
          nombre={p.nombre}
          bgColor={p.bg}
          textColor={p.texto}
          btnColor={p.boton}
          onClick={() => navigate("/personajes")}
        />
      )}
    />
  );
}
